import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/navigation/icons/x-close@2x.png'
import _imports_1 from '@/assets/_svg/icon-save.svg'


const _hoisted_1 = { class: "modal-window terms-and-conditions" }
const _hoisted_2 = { class: "terms-and-conditions-header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "icon-close"
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_6 = { class: "terms-and-conditions-body" }
const _hoisted_7 = {
  key: 0,
  class: "terms-and-conditions-body--title"
}
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  key: 2,
  class: "terms-and-conditions-body--text"
}
const _hoisted_10 = ["checked", "disabled"]
const _hoisted_11 = {
  class: "terms-and-conditions-checkbox--label",
  for: "checkbox-gtc-accepted"
}
const _hoisted_12 = {
  key: 4,
  class: "terms-and-conditions-body--title"
}
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = {
  key: 6,
  class: "terms-and-conditions-body--text"
}
const _hoisted_15 = ["checked", "disabled"]
const _hoisted_16 = {
  class: "terms-and-conditions-checkbox--label",
  for: "checkbox-dtp-accepted"
}
const _hoisted_17 = { class: "terms-and-conditions-buttons-bar" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_my_button = _resolveComponent("my-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ 'modal-overlay': true, mobile: _ctx.isMobile && _ctx.isTermsAndConditionsModalOpen })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "modal-close icon-small",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, _hoisted_4),
        (!_ctx.isAccepted)
          ? (_openBlock(), _createBlock(_component_my_button, {
              key: 0,
              class: "terms-and-conditions-header-btn",
              onClick: _withModifiers(_ctx.saveChanges, ["prevent"])
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_ctx.gtcData)
          ? (_openBlock(), _createElementBlock("h2", _hoisted_7, _toDisplayString(_ctx.gtcData.Title), 1))
          : _createCommentVNode("", true),
        (_ctx.gtcData && _ctx.gtcData.IsHtml)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "terms-and-conditions-body--text",
              innerHTML: _ctx.gtcData.Text
            }, null, 8, _hoisted_8))
          : (_ctx.gtcData)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.gtcData.Text), 1))
            : _createCommentVNode("", true),
        (_ctx.gtcData)
          ? (_openBlock(), _createElementBlock("div", {
              key: 3,
              ref: "refGtcCheckbox",
              class: _normalizeClass({
                        'terms-and-conditions-body--checkbox components-checkbox components-checkbox--left': true,
                        error: _ctx.gtcError,
                    })
            }, [
              _createElementVNode("input", {
                id: "checkbox-gtc-accepted",
                type: "checkbox",
                checked: !!_ctx.gtcAccepted || _ctx.isAccepted,
                disabled: _ctx.isAccepted,
                onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleGtcCheck()))
              }, null, 40, _hoisted_10),
              _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t(`components.modal.terms_and_conditions.gtc.label`)), 1)
            ], 2))
          : _createCommentVNode("", true),
        (_ctx.dtpData)
          ? (_openBlock(), _createElementBlock("h2", _hoisted_12, _toDisplayString(_ctx.dtpData.Title), 1))
          : _createCommentVNode("", true),
        (_ctx.dtpData && _ctx.dtpData.IsHtml)
          ? (_openBlock(), _createElementBlock("div", {
              key: 5,
              class: "terms-and-conditions-body--text",
              innerHTML: _ctx.dtpData.Text
            }, null, 8, _hoisted_13))
          : (_ctx.dtpData)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.dtpData.Text), 1))
            : _createCommentVNode("", true),
        (_ctx.dtpData)
          ? (_openBlock(), _createElementBlock("div", {
              key: 7,
              ref: "refDtpCheckbox",
              class: _normalizeClass({
                        'terms-and-conditions-body--checkbox components-checkbox components-checkbox--left': true,
                        error: _ctx.dtpError,
                    })
            }, [
              _createElementVNode("input", {
                id: "checkbox-dtp-accepted",
                type: "checkbox",
                checked: !!_ctx.dtpAccepted || _ctx.isAccepted,
                disabled: _ctx.isAccepted,
                onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleDtpCheck()))
              }, null, 40, _hoisted_15),
              _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t(`components.modal.terms_and_conditions.dtc.label`)), 1)
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_17, [
        (!_ctx.isAccepted)
          ? (_openBlock(), _createBlock(_component_my_button, {
              key: 0,
              onClick: _withModifiers(_ctx.saveChanges, ["prevent"])
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t(`components.modal.terms_and_conditions.submit.label`)), 1)
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 2))
}